import {
  isPromotionalOffer,
  publicOrLoyaltyOffers,
} from '../helpers/isOffer.helper';

import type { AvailableRoom, RoomOffers } from '~~/domains/graphql';

function getCheapestOffers(availableRoom: AvailableRoom): {
  public: RoomOffers;
  member: RoomOffers | undefined;
} {
  const publicOffers = publicOrLoyaltyOffers(
    (availableRoom.availabilityRoom?.offers ?? []) as RoomOffers[],
  ) as RoomOffers[];

  const memberOffers = (availableRoom.availabilityRoom?.offers ?? []).filter(
    offer => offer?.categories?.some(isPromotionalOffer),
  ) as RoomOffers[];

  // Sort public offers from the cheapest to the most expensive
  publicOffers.sort(
    (offer1, offer2) =>
      (offer1?.pricing?.amount?.hotelKeeper ?? 0) -
      (offer2?.pricing?.amount?.hotelKeeper ?? 0),
  );

  const publicOffer = publicOffers[0];
  // Find the member offer associated to the public offer
  const memberOffer = memberOffers.find(offer =>
    offer?.code?.startsWith(publicOffer.code ? `${publicOffer.code}-` : ''),
  );

  return { public: publicOffer, member: memberOffer };
}

function getOfferPrice(offer?: RoomOffers) {
  return offer?.pricing?.amount?.hotelKeeper ?? 0;
}

export function useAvailableRoomsSorted(allRooms: Ref<AvailableRoom[]>) {
  return computed(() => {
    const roomsCopy = [...(allRooms?.value || [])];
    return roomsCopy.sort((room1, room2) => {
      const cheapOfferRoom1 = getCheapestOffers(room1);
      const cheapestPriceRoom1 = getOfferPrice(cheapOfferRoom1.member)
        ? getOfferPrice(cheapOfferRoom1.member)
        : getOfferPrice(cheapOfferRoom1.public);

      const cheapOfferRoom2 = getCheapestOffers(room2);
      const cheapestPriceRoom2 = getOfferPrice(cheapOfferRoom2.member)
        ? getOfferPrice(cheapOfferRoom2.member)
        : getOfferPrice(cheapOfferRoom2.public);

      return cheapestPriceRoom1 - cheapestPriceRoom2;
    });
  });
}
